import * as React from 'react';

const Gr24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0D5EAF",
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M3.114 16.667A2 2 0 0 1 3 16v-.666h18V16q-.002.352-.114.667zM21 14v-1.333H7V10h2.667v1.333H21V10H9.667V8.667H21V8q-.002-.352-.114-.667H9.666v1.334H7V6H5.667v2.667H3V10h2.667v2.667H3V14z"
  }
));
Gr24.Size = 24;
Gr24.Title = "Gr";

export { Gr24 as default };
